import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import RfiContext from 'router/subrouters/DataRoom/providers/Rfi/Rfi.context';
import ReorderResizeTable from 'components/ReorderResizeTable';
import {
  BODY_CONTENT_GENERATE,
  CUSTOM_COL_SIZES,
  HEADING_TRANSLATIONS,
  TABLE_COLUMNS,
} from './data';
import { Button } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import { DataRoomRfiTemplate } from 'router/subrouters/DataRoom/models/DataRoomRfi';
import { useNavigate } from 'react-router-dom';
import { getDataRoomRoute } from 'utils';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';

import './RfiTemplatesTable.styles.scss';

type RfiTemplatesTableProps = {
  className?: string;
};

const RfiTemplatesTable: React.FC<RfiTemplatesTableProps> = (props) => {
  const { className } = props;

  const { isLoadingTemplates, rfiTemplates } = useContext(RfiContext);
  const {
    dataRoom: { _id },
  } = useContext(DataRoomContext);

  const classes = classNames('rfi-templates-table', className);

  const navigate = useNavigate();

  const { t } = useTranslation();

  const renderedContent = useMemo(
    () =>
      TABLE_COLUMNS.reduce(
        (acc, col) => ({
          ...acc,
          [col]: (template: DataRoomRfiTemplate) =>
            BODY_CONTENT_GENERATE[col]({
              template,
            }),
        }),
        {},
      ),
    [],
  );

  const headerColTransformation = useMemo(
    () => ({
      manage: () => (
        <Button
          onClick={() => navigate(getDataRoomRoute(_id, 'rfi/create-template'))}
        >
          {t('addNewTemplate')}
        </Button>
      ),
    }),
    [_id, navigate, t],
  );

  if (!isLoadingTemplates && !rfiTemplates.length) return null;

  return (
    <div className={classes}>
      <p>{t('templates')}</p>

      <ReorderResizeTable
        isDragDisabled
        isResizeDisabled
        columns={TABLE_COLUMNS as any}
        headingTranslations={HEADING_TRANSLATIONS}
        data={rfiTemplates as any}
        isDataLoading={isLoadingTemplates}
        tableContentTransformations={renderedContent}
        tableHeaderContentTransformations={headerColTransformation}
        customSizes={CUSTOM_COL_SIZES}
      />
    </div>
  );
};

export default RfiTemplatesTable;
